var helper = {
  getAddonsPrice: function() {
    let price = 0;
    let allOptions = document.querySelectorAll('#ymq-box .ymq-options-box:not([style*="display: none"]) input[data-price]:not(:disabled):checked');
    Array.from(allOptions).forEach(option => {
      console.log('OPTION:', option)
      price += parseFloat(option.dataset.price);
    });

    return price;
  },

  updateTotalPrice: function() {
    let addonsPrice = helper.getAddonsPrice();
    const price = parseFloat(document.querySelector('input[name="initial_price"]').value) / 100;
    
    document.querySelectorAll('span.price-value, .product-sticky-form__price').forEach(el => {
      el.textContent = '$' + parseFloat(price + addonsPrice).toFixed(2);
    });

    setTimeout(function() {
      helper.fillSelections();
    }, 100);
  },

  fillSelections: function() {
    document.querySelector('.selections > .container').textContent = '';

    let str = '';
    let options = document.querySelectorAll('.ymq-options-box');
    Array.from(options).forEach(option => {
      let label = option.querySelector('.ymq_lable').textContent;
      let input = option.querySelector('input:checked:not([disabled])');

      if (getComputedStyle(option).display == 'none' || option.disabled == true) {
        return;
      }

      let value = '<em>Not Selected</em>';

      if (input) {
        value = input.value;  
      }
      
      str += '<div class="item"><span>' + label + '</span><strong>' + value + '</strong></div>';
    });

    document.querySelector('.selections > .container').innerHTML = str;
  }
}

document.addEventListener('player-ready', (e) => {
  let configuration = {};
  let options = document.querySelectorAll('.threekit-option input');
  
  const fieldsMapping = e.detail.mapping;
  
  document.querySelector('.product--thumbnails-bottom .product__info').classList.add('visible');

  // update threekit configuration
  Array.from(options).forEach(option => {
    option.addEventListener('click', function(event) {
      setTimeout(() => {
        let name = this.name.replace('ymq[', '').replace(']', '');
        let value = this.value;

        for (let idx = 0; idx < fieldsMapping.length; idx++) {
          if (fieldsMapping[idx].fe.toLowerCase() == name.toLowerCase()) {
            name = fieldsMapping[idx].be;
            break;
          }
        }
  
        for (let idx = 0; idx < fieldsMapping.length; idx++) {
          if (fieldsMapping[idx].fe.toLowerCase() === value.toLowerCase()) {
            value = fieldsMapping[idx].be;
            break;
          }
        }

        // Needs to remove next check after "(MORE COMING SOON)" text will be removed on threekit
        if (name.toLowerCase() === 'shell color') {
          name = 'SHELL COLOR'
        }
  
        if (name.toLowerCase().includes('model-')) {
          name = 'Helmet Types'
        }
  
        if (name === 'Competition Level') {
          let models = document.querySelectorAll('div[data-name^="properties[Model-"]:not([style*="display: none"]) input[name^="properties[Model-"]:not(:disabled)')

          for (let index = 0; index < models.length; index++) {
            for (let idx = 0; idx < fieldsMapping.length; idx++) {
              if (fieldsMapping[idx].fe.toLowerCase() === models[index].value.split(' | ')[0].toLowerCase()) {
                const modelValue = models[index].value.split(' | ')[0];
                const modelValueMapped = fieldsMapping[idx].be
                configuration['Helmet Types'] = modelValueMapped
                break;
              }
            }
            
            break;
          }
          helper.updateTotalPrice()
        }
  
        configuration[name] = value;

        window.threekit.configurator.setConfiguration(configuration);
      }, 200);
    });

    // console.log('option', option);
    if (option.checked) {
      option.click();
      option.click();
    }
  });

  // update total price value & selection list
  let allOptions = document.querySelectorAll('#ymq-box input');
  Array.from(allOptions).forEach(option => {
    option.addEventListener('click', helper.updateTotalPrice);
  });
   
  // show tooltips
  let tooltips = document.querySelectorAll('span.ymq_tooltip_show');
  Array.from(tooltips).forEach(option => {
    option.style.display = 'block';
  });

  document.querySelectorAll('.ymq-options-box.toggle .ymq-option-title').forEach((el) => {
    el.addEventListener('click', function(event) {
      el.classList.toggle('closed');
    });
  });

  document.querySelectorAll('.selections > h4').forEach((el) => {
    el.addEventListener('click', function(event) {
      el.classList.toggle('open');
      el.childNodes[0].textContent = (el.classList.contains('open') ? 'Minimize' : 'View') + ' All Selections';
    });
  });

  helper.updateTotalPrice();
  helper.fillSelections();

  document.querySelector('.scrollbar .up').addEventListener('click', function(event) {
    event.preventDefault();
    
    let el =  document.querySelector('.product-meta');

    el.scroll({
      top: el.scrollTop - 100, 
      left: 0,
      behavior: 'smooth'
    });

    return false;
  });

  document.querySelector('.scrollbar .down').addEventListener('click', function(event) {
    event.preventDefault();
    
    let el =  document.querySelector('.product-meta');

    el.scroll({
      top: el.scrollTop + 100, 
      left: 0,
      behavior: 'smooth'
    });
    
    return false;
  });
  
  document.querySelector('.product-meta').addEventListener('scroll', (e) => {
    let el = document.querySelector('.product-meta');
    if (el.scrollTop < 50) {
      document.querySelector('.scrollbar .up').classList.add('disabled');
    } else {
      document.querySelector('.scrollbar .up').classList.remove('disabled');
    }

    if (el.scrollHeight - el.scrollTop == el.clientHeight) {
      document.querySelector('.scrollbar .down').classList.add('disabled');
    } else {
      document.querySelector('.scrollbar .down').classList.remove('disabled');
    }
  });

  /**/
  document.querySelector('.scroll-ctrl .up').addEventListener('click', function(event) {
    event.preventDefault();
    
    let el = document.querySelector('.scrollable');

    el.scroll({
      left: el.scrollLeft - 100, 
      top: 0,
      behavior: 'smooth'
    });

    return false;
  });

  document.querySelector('.scroll-ctrl .down').addEventListener('click', function(event) {
    event.preventDefault();
    
    let el =  document.querySelector('.scrollable');

    el.scroll({
      left: (el.scrollLeft + 100), 
      top: 0,
      behavior: 'smooth'
    });

    return false;
  });
  
  document.querySelector('.scrollable').addEventListener('scroll', (e) => {
    let el = document.querySelector('.scrollable');
    if (el.scrollLeft < 50) {
      document.querySelector('.scroll-ctrl .up').classList.add('disabled');
    } else {
      document.querySelector('.scroll-ctrl .up').classList.remove('disabled');
    }

    if (el.scrollWidth - el.scrollLeft == el.clientWidth) {
      document.querySelector('.scroll-ctrl .down').classList.add('disabled');
    } else {
      document.querySelector('.scroll-ctrl .down').classList.remove('disabled');
    }
  });
}, false);